<div class="h-full flex justify-center items-center p-4">
    <div class="w-full h-full p-8 flex flex-col justify-center items-center bg-white shadow-lg">
        <h1 class="text-2xl sm:text-3xl text-primary-700 font-normal text-center">Coming Soon</h1>
        <p class="text-sm text-accent-700 text-center mt-2">Our website is under construction</p>
        <button class="px-4 py-2 rounded-full bg-primary-800 text-md text-on-primary-800 hover:opacity-90 w-max mt-4" [routerLink]="'/app/home'">Go to Home</button>
    </div>
</div>